module["exports"] = [
  "BW",
  "BY",
  "BE",
  "BB",
  "HB",
  "HH",
  "HE",
  "MV",
  "NI",
  "NW",
  "RP",
  "SL",
  "SN",
  "ST",
  "SH",
  "TH"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de/address/state_abbr.js
// module id = 348
// module chunks = 0